import { useState } from 'react';
import { FaSearch, FaTrash, FaPlus, FaMinus } from 'react-icons/fa';
import { IoRibbonOutline, IoLeafOutline, IoStarOutline } from 'react-icons/io5';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {  Container ,Offcanvas,Button
,
Row,
Col,
ListGroup,
Image,

FormControl
, NavDropdown
} from 'react-bootstrap';
import { FaShoppingCart, FaUser ,FaGripHorizontal ,FaHome} from 'react-icons/fa';
import { useSelector , useDispatch} from 'react-redux';
import logo from '../assets/logo.webp'
import LanguageSelector from './LanguageSelector';
import AuthModal from './AuthModal';
import { useTranslation } from 'react-i18next';
import { logout } from '../slices/authSlice';
import shipped from '../assets/shipped.png'
import cancel from '../assets/cancel-n.png'
import MobileNavigationMenu from './MobileNavigationMenu';
import { removeFromCart, addToCart, openCart, closeCart } from '../slices/cartSlice';
import { useGetShoppingProductsQuery } from '../slices/productsApiSlice';
import { LinkContainer } from 'react-router-bootstrap';


// Split "تمر سكري كيلو" -> { title: "تمر سكري", variant: "كيلو" } (gruns-style name + variant)
const splitItemName = (name) => {
  if (!name) return { title: '', variant: '' };
  const sizes = ['نصف كيلو', 'ربع كيلو', 'علبة', 'كيلو', 'Half KG', 'Quarter KG', '1KG', 'Box', 'KG'];
  for (const sz of sizes) {
    const idx = name.indexOf(sz);
    if (idx > 0) return { title: name.slice(0, idx).trim(), variant: name.slice(idx).trim() };
  }
  return { title: name, variant: '' };
};

const Header = () => {
  const { cartItems, drawerOpen } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);
  const { data: shopData } = useGetShoppingProductsQuery(undefined, { skip: !drawerOpen });
  const [recosExpanded, setRecosExpanded] = useState(false);
  const [show, setShow] = useState(false);
  const [menu, setMenu] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [free, setFree] = useState(true);
  const handleClose = () => dispatch(closeCart());
  const handleShow = () => dispatch(openCart());
  const { t ,i18n} = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const location = useLocation();


  const handleSearch = () => {
    setSearchTerm('')
    navigate(`/shopping/products/search?term=${searchTerm}`);

  }


const dispatch = useDispatch();
    const handleLogout = () => {
      navigate('/')
        dispatch(logout());

    }

    const handleMenu = () => {
setMenu(false)
    }
    const removeFromCartHandler = (id) => {
      dispatch(removeFromCart(id));
    };

    const incQty = (item) => dispatch(addToCart({ ...item, qty: (item.qty || 1) + 1 }));
    const decQty = (item) => {
      if ((item.qty || 1) > 1) dispatch(addToCart({ ...item, qty: item.qty - 1 }));
    };
    const goCheckout = () => {
      dispatch(closeCart());
      navigate(cartItems.length ? '/checkout' : '/shopping');
    };
    const cartSubtotal = cartItems
      .reduce((acc, item) => acc + item.qty * item.price, 0)
      .toFixed(2);

    const minimalHeader =
      location.pathname.indexOf('/checkout') === 0 || location.pathname.indexOf('/pay') === 0;
    if (minimalHeader) {
      return (
        <header dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className='checkout-minimal-header'>
          <Link to='/'>
            <img src={logo} alt="Tamrat" width="120" />
          </Link>
        </header>
      );
    }

    return (
      <header dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
    {free && (
        <div className="py-1" style={{ backgroundColor: '#7C9D64' }}>
      <Container>
        <Row className="d-flex align-items-center">
          <Col>
            <h6 className='text-center' style={{ margin: 'auto' }}>
              <Image src={shipped} width="40" height="40" style={{ margin: 'auto' }} /> {t('freeShipping')}
            </h6>
          </Col>
          <Col xs={{ order: 'first' }} className="text-end" style={{ position: 'absolute', right: '2%', top: '1.5%' }}>
            <Image src={cancel} width="20" height="20" onClick={() => setFree(false)} />
          </Col>
        </Row>
      </Container>
    </div>
    )}
    
 

      <Offcanvas show={drawerOpen} onHide={handleClose} placement='end' dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className='cart-drawer'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t('acc1')}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='d-flex flex-column p-0'>
          {cartItems.length > 0 && (
            <div className='cart-ship-bar'>
              <div className='cart-ship-text'>
                {Number(cartSubtotal) >= 250
                  ? (i18n.language === 'en' ? '✅ Free shipping — applied to your order' : '✅ شحن مجاني — تم تطبيقه على طلبك')
                  : (i18n.language === 'en'
                      ? `Add ${(250 - Number(cartSubtotal)).toFixed(2)} SAR to get free shipping`
                      : `أضِف بقيمة ${(250 - Number(cartSubtotal)).toFixed(2)} ر.س لتحظى بالتوصيل المجاني`)}
              </div>
              <div className='cart-ship-track'>
                <div className='cart-ship-fill' style={{ width: `${Math.min(100, (Number(cartSubtotal) / 250) * 100)}%` }} />
              </div>
            </div>
          )}

          <div className='cart-drawer-items'>
            {cartItems.length === 0 ? (
              <p className='text-center text-muted mt-5'>
                {i18n.language === 'en' ? 'Your cart is empty' : 'سلتك فارغة'}
              </p>
            ) : (
              <>
              {cartItems.map((item) => (
                <div key={item.id} className='cart-drawer-row'>
                  <img src={item.image_path} alt={item.name_en} className='cart-drawer-thumb' />
                  <div className='cart-drawer-info'>
                    {(() => {
                      const full = i18n.language === 'en' ? item.name_en : item.name_ar;
                      const { title, variant } = splitItemName(full);
                      return (
                        <>
                          <Link to={`/products/${item.slug}`} onClick={handleClose} className='cart-drawer-name'>{title || full}</Link>
                          {variant ? <div className='cart-drawer-variant'>{variant}</div> : null}
                        </>
                      );
                    })()}
                    <div className='cart-drawer-price'>{(item.price * item.qty).toFixed(2)} {t('sar')}</div>
                    <div className='cart-drawer-qty'>
                      <button type='button' onClick={() => decQty(item)} aria-label='minus'><FaMinus size={11} /></button>
                      <span>{item.qty}</span>
                      <button type='button' onClick={() => incQty(item)} aria-label='plus'><FaPlus size={11} /></button>
                    </div>
                  </div>
                  <button type='button' className='cart-drawer-remove' onClick={() => removeFromCartHandler(item.id)} aria-label='remove'>
                    <FaTrash size={14} />
                  </button>
                </div>
              ))}
              {(() => {
                const all = (shopData?.products || []).filter((p) => !cartItems.some((c) => c.id === p.id));
                if (!all.length) return null;
                const shown = recosExpanded ? all.slice(0, 6) : all.slice(0, 3);
                return (
                  <div className='cart-recos'>
                    <div className='cart-recos-title'>
                      {i18n.language === 'en' ? 'Add to your order' : 'أضف لطلبك'}
                    </div>
                    {shown.map((p) => (
                      <div key={p.id} className='cart-reco-row'>
                        <img src={p.image_path} alt='' className='cart-reco-thumb' />
                        <div className='cart-reco-info'>
                          <span className='cart-reco-name'>{i18n.language === 'en' ? p.name_en : p.name_ar}</span>
                          <span className='cart-reco-price'>{parseFloat(p.price).toFixed(2)} {t('sar')}</span>
                        </div>
                        <button type='button' className='cart-reco-add' onClick={() => dispatch(addToCart({ ...p, qty: 1 }))}>
                          + {i18n.language === 'en' ? 'Add' : 'أضف'}
                        </button>
                      </div>
                    ))}
                    {all.length > 3 && (
                      <button type='button' className='cart-recos-more' onClick={() => setRecosExpanded((v) => !v)}>
                        {recosExpanded ? (i18n.language === 'en' ? 'Show less' : 'عرض أقل') : (i18n.language === 'en' ? 'Show more' : 'عرض المزيد')}
                      </button>
                    )}
                  </div>
                );
              })()}
              </>
            )}
          </div>

          {cartItems.length > 0 && (
            <div className='cart-drawer-footer'>
              <div className='cart-drawer-subtotal'>
                <span>{i18n.language === 'en' ? 'Subtotal' : 'المجموع'}</span>
                <span>{cartSubtotal} {t('sar')}</span>
              </div>
              <p className='cart-drawer-note'>
                {i18n.language === 'en' ? 'Shipping calculated at checkout' : 'يحسب الشحن عند إتمام الطلب'}
              </p>
              <button className='cart-drawer-checkout' onClick={goCheckout}>
                🔒 {i18n.language === 'en' ? 'Secure Checkout' : 'إتمام الطلب'}
              </button>
              <div className='cart-trust-row'>
                <span><IoRibbonOutline /><span>{i18n.language === 'en' ? 'Carefully selected dates' : 'تمور مختارة بعناية'}</span></span>
                <span><IoLeafOutline /><span>{i18n.language === 'en' ? 'No pesticides or chemicals' : 'بلا مبيدات أو مواد كيميائية'}</span></span>
                <span><IoStarOutline /><span>{i18n.language === 'en' ? '4.8 stars from 1,000+ reviews' : '4.8 نجوم من +1,000 تقييم'}</span></span>
              </div>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
              <div className="header-top">
            <div className="container">
                <ul className="header-social-container">
                    {/* Add your social icons here */}
                </ul>
                <div className="header-user-actions">
                <button className="action-btn headbutton">
                {
                        userInfo ? (     <NavDropdown title={<FaUser size={30}/>} id="basic-nav-dropdown">
                          
                          <NavDropdown.Item>
                          <Link to={'/profile'}>
                            {t('account6')}  </Link></NavDropdown.Item>
                        
                        <NavDropdown.Divider />
                        <NavDropdown.Item onClick={handleLogout}>{t('account7')}</NavDropdown.Item>
                        {
  userInfo && userInfo.user.type === 13 && (
 
      <LinkContainer to='/admin/orderlist'>
        <NavDropdown.Item>Admin</NavDropdown.Item>
      </LinkContainer>

  )
}
                      </NavDropdown>) : (<FaUser size={30} onClick={() => setShowModal(true)} />)
                    }


                
                </button>
                        <button className="action-btn headbutton" onClick={handleShow}>
                        <FaShoppingCart size={30}/>
                            <span className="count" > {cartItems.reduce((a, c) => a + c.qty, 0)}</span>
                        </button>
                    
                    {/* <span>lang</span> */}
                    <LanguageSelector />
                    
                </div>
            </div>
        </div>
      <div className="header-main">
          
          <div className="container">
              
          <Link  to='/' className='header-logo'>
                  <img src={logo} alt="Anon's logo" width="120" />
         </Link>
         <AuthModal show={showModal} handleClose={()=>setShowModal(false)} />

              <nav className="desktop-navigation-menu">
                  <div className="container">
                      <ul className="desktop-menu-category-list">
                          <li className="menu-category">
                         
                              <Link  to='/' className="menu-title">
                              {t('header1')}
                                </Link>
                          </li>
                          <li className="menu-category">
                              
                              <Link  to='/shopping' className="menu-title">
                              {t('header2')}
                                </Link>
                              <ul className="dropdown-list" style={{ position: 'absolute', top: '100%', left: 0 }}>
                                  <li className="dropdown-item">
                                  <Link  to='/ajwa-date' className="menu-title">
                                  {t('header3')}
                                </Link>
                                  </li>

                            
                                  <li className="dropdown-item">
                                  <Link  to='/sukari-date' className="menu-title">
                                  {t('header4')}
                                </Link>
                                  </li>
                                  <li className="dropdown-item">
                                  <Link  to='/majhool-date' className="menu-title">
                                  {t('header5')}
                                </Link>
                                  </li>
                                  <li className="dropdown-item">
                                  <Link  to='/mabroom-date' className="menu-title">
                                  {t('header6')}
                                </Link>
                                  </li>
                                  <li className="dropdown-item">
                                  <Link  to='/sagie-date' className="menu-title">
                                  {t('header7')}
                                </Link>
                                  </li>
                              </ul>
                          </li>
                          <li className="menu-category">
                              <Link to="/date-packages" className="menu-title">{t('header8')}</Link>
                          </li>
                          <li className="menu-category">
                              <Link to="/blog/معلومات-عامة-شجر-النخيل" className="menu-title">{t('header9')}</Link>
                          </li>
                          {/* <li className="menu-category">
                              <a to="/about" className="menu-title">About us</a>
                          </li> */}
                          <li className="menu-category">
                              <Link to="/contact-us" className="menu-title">{t('header10')}</Link>
                          </li>
                      </ul>
                  </div>
              </nav>
            
                {i18n.language === 'en' ? (
        <div style={{position:'relative'}}>
        <FormControl
      type="text"
      placeholder={t('find')}
      className="mr-sm-2 rounded-pill"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}

    /> 
    <FaSearch style={{position:'absolute',top:'15' ,right:'20'}} onClick={handleSearch}/>
        </div>
                ):(
                  <div style={{position:'relative'}}>
                  <FormControl
                type="text"
                placeholder={t('find')}
                className="mr-sm-2 rounded-pill"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
      
              /> 
              <FaSearch style={{position:'absolute',top:'15' ,left:'20'}} onClick={handleSearch}/>
                  </div>
                )}
          
               
          </div>
      </div>
      


      <div className="mobile-bottom-navigation">
            <button className="action-btn headbutton" data-mobile-menu-open-btn onClick={()=> setMenu(true)}>
            <FaGripHorizontal />
            </button>
                <button className="action-btn headbutton">
                <FaShoppingCart onClick={handleShow}/>
                    <span className="count">{cartItems.reduce((a, c) => a + c.qty, 0)}</span>
                </button>
            
                <Link to={'/'} className="action-btn headbutton">
                <FaHome />
                </Link>
         
            {userInfo ? (
                 <Link to={'/profile'} className="action-btn headbutton" >
                 <FaUser />
                 </Link>
            ) : (
                 <button type="button" className="action-btn headbutton" >
            <FaUser onClick={() => setShowModal(true)}/>
            </button>
            )}
        </div>


{menu && (
  <MobileNavigationMenu closeMenu={handleMenu}/>
)}

      {/* <nav className="mobile-navigation-menu has-scrollbar" >
          <div className="menu-top">
              <h2 className="menu-title">Menu</h2>
              <button className="menu-close-btn headbutton" data-mobile-menu-close-btn>
                  <i className="fas fa-times"></i>
              </button>
          </div>
          <ul className="mobile-menu-category-list">
              <li className="menu-category">
                  <a href="/home" className="menu-title">Home</a>
              </li>
              <li className="menu-category">
                  <button className="accordion-menu headbutton" data-accordion-btn>
                      <p className="menu-title">Dates</p>
                      <div>
                          <i className="fas fa-plus add-icon"></i>
                          <i className="fas fa-minus remove-icon"></i>
                      </div>
                  </button>
                  <ul className="submenu-category-list" data-accordion>
                      <li className="submenu-category">
                          <a href="/ajwa.date" className="submenu-title">Ajwa Date</a>
                      </li>
                      <li className="submenu-category">
                          <a href="/sukari.date" className="submenu-title">Sukari Date</a>
                      </li>
                      <li className="submenu-category">
                          <a href="/majhool.date" className="submenu-title">Majhool Date</a>
                      </li>
                      <li className="submenu-category">
                          <a href="/mabroom.date" className="submenu-title">Mabroom Date</a>
                      </li>
                  </ul>
              </li>
              <li className="menu-category">
                  <a href="/all-sizes" className="menu-title">Date Sizes</a>
              </li>
              <li className="menu-category">
                  <a href="/blog.index" className="menu-title">Blog</a>
              </li>
              <li className="menu-category">
                  <a href="/contact.us" className="menu-title">Contact us</a>
              </li>
          </ul>
          <div className="menu-bottom">
              <ul className="menu-category-list">
                  <li className="menu-category">
                      <button className="accordion-menu headbutton" data-accordion-btn>
                          <p className="menu-title">Language</p>
                          <i className="fas fa-caret-back caret-back"></i>
                      </button>
                      <ul className="submenu-category-list" data-accordion>
                          <li className="submenu-category">
                              <a rel="alternate" href="/en" className="submenu-title">English</a>
                          </li>
                          <li className="submenu-category">
                              <a rel="alternate" href="/ar" className="submenu-title">العربية</a>
                          </li>
                      </ul>
                  </li>
              </ul>
              <ul className="menu-social-container">
                  <li>
                      <a href="#" className="social-link">
                          <i className="fab fa-facebook"></i>
                      </a>
                  </li>
                  <li>
                      <a href="#" className="social-link">
                          <i className="fab fa-twitter"></i>
                      </a>
                  </li>
                  <li>
                      <a href="#" className="social-link">
                          <i className="fab fa-instagram"></i>
                      </a>
                  </li>
                  <li>
                      <a href="#" className="social-link">
                          <i className="fab fa-linkedin"></i>
                      </a>
                  </li>
              </ul>
              <span>logout</span>
          </div>
      </nav> */}
  </header>
    );
  };

export default Header;